import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
// import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    label: {
      // marginBottom: theme.spacing(),
      marginBottom: '8px !important',
    },
    value: {
      // marginBottom: theme.spacing(),
      marginBottom: '8px !important',
      wordWrap: 'break-word',
    },
  })
);

interface ReadOnlyFieldProps {
  /**
   *
   */
  label?: string;

  /**
   *
   */
  value?: string;

  /**
   * Custom component;
   */
  Component?: JSX.Element;

  /**
   * Don't render field if no value is provided
   */
  alwaysShow?: boolean;
}

export function ReadOnlyField({
  label,
  value,
  Component,
  alwaysShow,
}: ReadOnlyFieldProps) {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  if (!alwaysShow && !value && !Component) {
    return <></>;
  }

  return (
    <Grid container>
      <Grid item xs={4}>
        <Typography variant="body1" className={classes.label}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        {Component ? (
          Component
        ) : (
          <Typography variant="body2" className={classes.value}>
            {value ??
              formatMessage({
                id: 'unspecified',
                defaultMessage: 'Nespecifikováno',
              })}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}
